export enum PositionOfDialog {
  TOP,
  BOTTOM,
  LEFT,
  RIGHT
}
